import React, { useState } from 'react';
import { formatMomentDate } from "../../../../../utils/dateHelper";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInitial } from '../../../../../utils/otherHelopers';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import ExperienceModal from '../../../../../components/modals/UserProfile/ExperienceModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserExperience, updateUserExperience, deleteUserExperience } from '../../../../../redux/slice/allUsersSlice';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';

const Experience = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const { experienceLoading } = useSelector((state) => state.allUsers);

    const handleUpsertExperience = (data) => {
        const action = currentItem
            ? updateUserExperience({ id: id, experienceId: currentItem.id, data })
            : addUserExperience({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Experience ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} experience`);
            });
    };

    const handleDeleteExperience = () => {
        dispatch(deleteUserExperience({ id: id, experienceId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Experience deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete experience");
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Experience</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />
            </div>
            {userDetail?.experiences?.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    {userDetail.experiences.map((exp, index) => (
                        <div key={index} className="p-3 border rounded-3 bg-light-subtle position-relative custom-card">
                            <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                                <button
                                    className="post-action-btn edit-btn border bg-white"
                                    onClick={() => {
                                        setCurrentItem(exp);
                                        setShowModal(true);
                                    }}
                                >
                                    <EditIcon width={14} height={14} color="#007bff" />
                                </button>
                                <button
                                    className="post-action-btn delete-btn border bg-white"
                                    onClick={() => {
                                        setItemToDelete(exp.id);
                                        setShowDeletePopup(true);
                                    }}
                                >
                                    <Delete02Icon size={14} />
                                </button>
                            </div>
                            <div className="d-flex gap-3">
                                <div className="profile-icon rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center fw-bold mt-1" style={{ width: "40px", height: "40px", flexShrink: 0 }}>
                                    {getUserInitial(exp.job_title || "?")}
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="mb-1 fw-bold text-dark">{exp.job_title || "-"}</h6>
                                    <p className="mb-1 text-muted small fw-semibold">{exp.organization || "-"}{exp.employment_type ? ` • ${exp.employment_type}` : ""}</p>
                                    <p className="mb-2 text-muted small" style={{ fontSize: '11px' }}>
                                        {exp.from_date ? formatMomentDate(exp.from_date, "MMM YYYY") : ""} - {exp.is_current ? "Present" : (exp.to_date ? formatMomentDate(exp.to_date, "MMM YYYY") : "")}
                                        {exp.location ? ` • ${exp.location}` : ""}{exp.location_type ? ` (${exp.location_type})` : ""}
                                    </p>
                                    {exp.description && (
                                        <p className="mb-0 text-secondary small text-break" style={{ whiteSpace: 'pre-line', lineHeight: '1.5' }}>{exp.description}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No experiences listed.</p>
                </div>
            )}

            <ExperienceModal
                isOpen={showModal}
                onClose={() => {
                    setShowModal(false);
                    setCurrentItem(null);
                }}
                onSubmit={handleUpsertExperience}
                experience={currentItem}
                isLoading={experienceLoading}
                title={currentItem ? "Edit Experience" : "Add Experience"}
                size="lg"
            />

            <DeletePopup
                show={showDeletePopup}
                onHide={() => {
                    setShowDeletePopup(false);
                    setItemToDelete(null);
                }}
                onConfirm={handleDeleteExperience}
                content="Are you sure you want to delete this experience?"
                saveTitle="Delete"
                disabled={experienceLoading}
            />
        </div>
    );
};

export default Experience;
